// import React from 'react';
// import { Provider } from 'react-redux';
// import store from '../../../utils/store'; // Correct path to the global store
import BookWorksheetPageEnh from './BookWorksheetPage-enh';

/**
 * BookWorksheetPageWrapperEnh component
 * Wrapper for the enhanced BookWorksheetPage component that provides Redux store access
 * @returns {JSX.Element} BookWorksheetPageWrapperEnh component
 */
const BookWorksheetPageWrapperEnh = () => {
  return (
    // <Provider store={store}>
    <BookWorksheetPageEnh />
    // </Provider>
  );
};

export default BookWorksheetPageWrapperEnh;
